import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
import { Flex, Alert, AlertIcon, Text, Link } from '@chakra-ui/core';
import HybridImage from '../../components/HybridImage';
import hashingSrc from '@/assets/images/hashing.png';
import flowSrc from '@/assets/images/flow.png';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Introduction`}</h1>
    <h2>{`This solution`}</h2>
    <p>{`Tesfy provides a `}<strong parentName="p">{`simple`}</strong>{` and `}<strong parentName="p">{`free`}</strong>{` but `}<strong parentName="p">{`complete solution`}</strong>{` to develop A/B Tests and Feature Flags on both Server and Client Side without relying in any storage layer while providing the best possible performance.`}</p>
    <h2>{`How does it work ?`}</h2>
    <p>{`The tesfy `}<inlineCode parentName="p">{`Engine`}</inlineCode>{` allocates users in a given experiment or feature depending on the configuration that is set. This is a `}<strong parentName="p">{`deterministic`}</strong>{` process, which means that if the configuration is the same, the allocation will always be the same. To ensure a correct distribution a hash function is used.`}</p>
    <h3>{`Hash function`}</h3>
    <p>{`A hash function is any function that can be used to map data of arbitrary size to fixed size values. The values returned by a hash function are usually called hashes.`}</p>
    <p>{`In this case the `}<inlineCode parentName="p">{`Engine`}</inlineCode>{` takes a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` (e.g. `}<inlineCode parentName="p">{`4qz936x2-62ex`}</inlineCode>{`) and a experiment or feature `}<inlineCode parentName="p">{`key`}</inlineCode>{` (e.g. `}<inlineCode parentName="p">{`experiment-1`}</inlineCode>{`) defined in the configuration to build a enhanced key that will be the concatenation of both of them. From this new key a hash is created by using a hash function.`}</p>
    <HybridImage my={8} src={hashingSrc} alt="Hashing process" mdxType="HybridImage" />
    <h3>{`Bucketing`}</h3>
    <p>{`Currently the hash function used is `}<strong parentName="p">{`MurmurHash`}</strong>{` (this will be able to be configured in the future). MurmurHash is a non-cryptographic hash function suitable for general hash-based lookup.`}</p>
    <p>{`The following code shows how a bucket is created from a hash value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const enhancedKey = '4qz936x2-62ex-experiment-1';
const hash = murmurhashv3(enhancedKey, 1);
const ratio = hash / MAX_VALUE; // value between 0 a 1
const bucket = parseInt(hashRatio * TOTAL_BUCKETS, 10) // value between 0 a 10000
`}</code></pre>
    <p>{`Once the bucket is created. It will be compared with the bucketing ranges generated by the allocation defined in the configuration. If the bucket is within one of the ranges, the proper variation will be assigned and if not it will be treated as excluded.`}</p>
    <h3>{`Flow`}</h3>
    <p>{`To determine which variation is assigned to an experiment the following flow is executed.`}</p>
    <HybridImage my={8} src={flowSrc} alt="Flow" mdxType="HybridImage" />
    <ul>
      <li parentName="ul">{`Forced variation assignments are checked. Forcing variations could be useful for cases like `}<strong parentName="li">{`testing`}</strong>{` or `}<strong parentName="li">{`whitelisting`}</strong>{`.`}</li>
      <li parentName="ul">{`Sticky bucketing querying the storage layer is checked.`}</li>
      <li parentName="ul">{`Audience evaluation, if the audience does not match, no variation will be assigned.`}</li>
      <li parentName="ul">{`Bucketing.`}</li>
      <li parentName="ul">{`Sticky bucketing persisting the variation in the storage layer.`}</li>
    </ul>
    <Alert my={4} status="warning" variant="left-accent" overflow="initial" mdxType="Alert">
  <AlertIcon mdxType="AlertIcon" />
  <Text mdxType="Text">Providing a storage layer is optional. It's only required if you want to enable Sticky Bucketing.</Text>
    </Alert>
    <p>{`A reduced flow is executed in the case of features. The storage steps will be skipped since this only applies to experiments.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      